export const ChatInput = {
  mounted() {
    this.el.addEventListener("keydown", (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "a") {
        e.stopPropagation();
        this.el.select();
        return;
      }

      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        if (this.el.value.trim() !== "") {
          this.el.form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        }
        setTimeout(() => this.resize(), 0);
      }
    });

    this.el.addEventListener("input", () => this.resize());

    this.resize();

    if (this.el.hasAttribute("autofocus")) {
      this.el.focus();
    }

    this.handleEvent("focus-chat-input", () => {
      this.el.focus();
    });
  },

  updated() {
    this.resize();
  },

  resize() {
    const maxHeight = 200;
    this.el.style.height = "auto";
    const scrollHeight = this.el.scrollHeight;
    const newHeight = Math.min(scrollHeight, maxHeight);
    this.el.style.height = newHeight + "px";
    this.el.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
  },
};
